(function () {
  "use strict";

  CatalogCtrl.$inject = ['$scope', '$rootScope', '$window', 'resolveData', 'mtypes', 'catalogResource', '$location', 'Validation', '$timeout', 'catalogModel', 'accountService', 'accountFeatures', 'authView', 'trainerPrivilege'];
  angular
    .module('trainerWebApp.controllers')
    .controller('CatalogCtrl', CatalogCtrl);

  function CatalogCtrl($scope, $rootScope, $window, resolveData, mtypes, catalogResource, $location, Validation, $timeout,
                       catalogModel, accountService, accountFeatures, authView, trainerPrivilege) {

    var userRole = trainerPrivilege.roles();

    // enforce catalog feature
    if ((!~accountFeatures.features.indexOf(mtypes.featureEntry.courseCatalog) && !authView.isActiveAdvancedtrial()) || !userRole.canViewCatalogs) {
      $location.path('/TMS/Home');
      return;
    }

    $window.document.title = "Catalog | Mindflash Training Management System";
    $rootScope.page = {name: 'catalog', title: "Catalog"};

    var dereg = $rootScope.$on('catalogSendEmailModalClosed', function () {
      $timeout(function () {
        $scope.viewState.dirty = false;
        midtierCallComplete();
      });
    });

    $scope.allGroups = _.map(resolveData.groups, function (value) {
      return {id: value.id, text: value.name}
    });

    catalogModel.setCatalog(resolveData.catalog);
    $scope.catalog = catalogModel.catalog;
    $scope.traineeAccessToggle = $scope.catalog.traineeAccessType !== 'None';

    $scope.viewState = {
      dirty: false,
      operationInProgress: false,
      addItemsUrl: '#/TMS/Catalog/' + catalogModel.catalog.id + '/addContent'
    };
    resolveData = null;

    $scope.sortableOptions = {
      disabled: mfConfig.permissionsName === 'Manager',
      placeholder: "catalog-content-item-under",
      tolerance: 'pointer',
      axis: 'y',
      stop: function () {
        //Super crazy fix to force ngRepeat to redraw according to the model to work around a DOM bug in jquery-ui
        var prevModel = catalogModel.catalog.items;
        catalogModel.catalog.items = [prevModel[0]];
        catalogModel.catalog.items = prevModel;
        calcSetDirty();
      }
    };

    $scope.courseAccessTypes = [
      {
        mtype: 'ExistingUserSelfRegister',
        text: 'Current Users',
        subtext: 'Existing trainees can enroll'
      },
      {
        mtype: 'PublicSelfRegister',
        text: 'Public',
        subtext: 'Anyone with a link can register'
      }
    ];

    $scope.traineeAccessTypes = [
      {
        mtype: 'AllTrainees',
        text: 'Available for all trainees'
      },
      {
        mtype: 'Groups',
        text: 'Only these groups:'
      }
    ];

    $scope.selectGroupsOptions = {
      width: 'off',
      closeOnSelect: false,
      maximumInputLength: 40,
      clearOnSelect: true,
      data: $scope.allGroups
    };

    $scope.save = function () {
      midtierCallInProgress();

      var toSave = catalogModel.cleanCatalogForServer();

      catalogResource.update(toSave, function (res) {
        catalogModel.catalog.amtTrainees = res.amtTrainees;
        catalogModel.save();
        $scope.viewState.dirty = false;
        midtierCallComplete();
      }, midtierCallComplete);
    };

    function fireAndForgetSave() {
      if (!catalogModel.catalogDirty()) return;

      catalogModel.save();
      $scope.viewState.dirty = false;
      $scope.save();
    }

    $scope.cancel = function () {
      catalogModel.revert();
      $scope.catalog = catalogModel.catalog;
      $scope.traineeAccessToggle = $scope.catalog.traineeAccessType !== 'None';
      $scope.viewState.dirty = false;
    };

    function calcSetDirty() {
      $scope.viewState.dirty = catalogModel.catalogDirty();
    }

    $scope.calcSetDirty = calcSetDirty;

    $scope.removeItem = function (index) {
      if (!catalogModel.catalog.items[index]) return;
      catalogModel.removeItem(index);
      calcSetDirty();
    };

    Validation.addValidation(validate);

    var nextLocation;

    function validate() {
      if (!catalogModel.catalogDirty())
        return true;

      nextLocation = $rootScope.newLocation.next;
      $scope.$broadcast('showUnsavedChanges', {
        cancelEventName: 'cancelSelection',
        leaveEventName: 'leaveCatalog',
        text: 'By leaving this page, your changes will be lost. Are you sure you want to continue?',
        title: 'Unsaved Changes',
        leaveButtonTitle: 'Yes',
        cancelButtonTitle: 'No'
      });
      return false;
    }

    $scope.$on('cancelSelection', angular.noop);

    $scope.$on('leaveCatalog', function () {
      $scope.cancel();

      $location.path(nextLocation.path).search(nextLocation.search);
      nextLocation = null;
    });

    $scope.toggleAccessType = function () {
      catalogModel.catalog.accessType = $scope.catalog.accessType;
      $scope.catalog = catalogModel.catalog;
      calcSetDirty();
    };

    $scope.toggleCourseAccessType = function () {
      catalogModel.catalog.courseAccessType = $scope.catalog.courseAccessType;
      $scope.catalog = catalogModel.catalog;
      calcSetDirty();
    };

    $scope.toggleTraineeAccessType = function () {
      catalogModel.catalog.traineeAccessType = $scope.traineeAccessToggle ? "AllTrainees" : "None";
      $scope.catalog = catalogModel.catalog;
      calcSetDirty();
    };

    $scope.changeTraineeAccessType = function () {
      catalogModel.catalog.traineeAccessType = $scope.catalog.traineeAccessType;
      $scope.catalog = catalogModel.catalog;
      calcSetDirty();
    };

    $scope.changeCatalogGroups = function () {
      catalogModel.catalog.groups = $scope.catalog.groups;
      $scope.catalog = catalogModel.catalog;
      calcSetDirty();
    };

    $scope.openShareUrlModal = function () {
      if ($scope.catalogIsPrivate()) return;
      fireAndForgetSave();

      var params = {
        url: catalogModel.catalog.url,
        type: "catalog"
      };
      $rootScope.$broadcast('openShareUrlRequestedEvent', params);
    };

    $scope.shareToEmail = function ($shareEvent) {
      if ($scope.catalogIsPrivate()) return;
      fireAndForgetSave();

      $shareEvent.type = 'email';
      $shareEvent.url = catalogModel.catalog.url;
      $shareEvent.description = catalogModel.catalog.description || "";
      $shareEvent.companyName = accountService.accountInfo.companyName;
      $shareEvent.title = catalogModel.getName();
    };

    $scope.shareToFacebook = function ($shareEvent) {
      if ($scope.catalogIsPrivate()) return;
      fireAndForgetSave();

      $shareEvent.type = 'facebook';
      $shareEvent.url = catalogModel.catalog.url;
      $shareEvent.description = catalogModel.catalog.description || "";
      $shareEvent.title = catalogModel.getName();
      $shareEvent.companyLogoURL = accountService.accountInfo.companyLogoUrl;
    };

    $scope.shareToLinkedIn = function ($shareEvent) {
      if ($scope.catalogIsPrivate()) return;
      fireAndForgetSave();

      $shareEvent.type = 'linkedin';
      $shareEvent.url = catalogModel.catalog.url;
      $shareEvent.title = catalogModel.getName();
    };

    $scope.shareToTwitter = function ($shareEvent) {
      if ($scope.catalogIsPrivate()) return;
      fireAndForgetSave();

      $shareEvent.type = 'twitter';
      $shareEvent.url = catalogModel.catalog.url;
      $shareEvent.companyName = accountService.accountInfo.companyName;
      $shareEvent.title = catalogModel.getName();
      $shareEvent.objectId = catalogModel.catalog.id;
    };

    $scope.shareToYammer = function ($shareEvent) {
      if ($scope.catalogIsPrivate()) return;
      fireAndForgetSave();

      $shareEvent.type = 'yammer';
      $shareEvent.url = catalogModel.catalog.url;
    };

    $scope.catalogIsPrivate = function () {
      return $scope.catalog.accessType == 'CatalogNotShared';
    };

    $scope.getShareCatalogLinkClass = function () {
      return $scope.catalogIsPrivate() ? 'disabled' : '';
    };

    $scope.onAddContentClick = function () {
      fireAndForgetSave();
      $location.path('/TMS/Catalog/' + catalogModel.catalog.id + '/addContent');
    };

    $scope.$on('$destroy', function () {
      Validation.removeValidation(validate);
    });

    $scope.$on('appOnBeforeUnload', function (e, customWarnings) {
      nextLocation = null;
      if (catalogModel.catalogDirty())
        e.preventDefault();
    });

    function midtierCallInProgress() {
      $scope.sortableOptions.disabled = true;
      $scope.viewState.operationInProgress = true;
    }

    function midtierCallComplete() {
      $scope.sortableOptions.disabled = false;
      $scope.viewState.operationInProgress = false;
    }

    $scope.$on('$destroy', function () {
      dereg();
    });
  }

})();
